import { DependencyList, useCallback, useEffect, useRef } from "react";

import { AnyFn } from "@/common";

export function useCallbackRef<T extends AnyFn>(
  callback: T | undefined,
  deps: DependencyList = []
) {
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  });

  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useCallback(((...args) => callbackRef.current?.(...args)) as T, deps);
}
